let utils = {
    checkPass: {
        msg01: "Min password ",
        msg02: "Characters, max ",
        msg03: " Characters",
        msg04: "Contains at least 3 of numbers, uppercase letters, lowercase letters and special characters",
        msg05: "Must contain numbers, uppercase letters, lowercase letters and special characters",
        msg06: "No more than one occurrence of the same character",
        msg07: "Time",
        msg08: "Password cannot contain username",
        msg09: "Password cannot contain phone number",
        msg10: "Password cannot contain email prefix",
        msg11: "Password cannot contain username reversed",
    },
    checkPwd: {
        msg: "Verification passed"
    },
}

export default utils